import * as React from "react";
import { IconProps } from "./types";

export default function StartDate({ svgProps, pathProps }: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        d="M21 3H18V1H16V3H8V1H6V3H3V21H21V3ZM19 19H5V8H19V19Z"
        fill="currentColor"
        {...pathProps}
      />
    </svg>
  );
}
